import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../../features/site/siteSlice'

import { serviceMap } from '../../../../utils/common'
import FacebookAdsClaimCard from '../../../Admin/ServiceTypes/FacebookAds'

import ServiceCardBase from '../../ServiceCardBase'

function FacebookAds({ onSave, onCancel}){
    const dispatch = useDispatch()
    
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        fb: undefined
                    }
                }
            }
        }))
    }


    return <ServiceCardBase 
        title="Facebook Ads" 
        header="Facebook Ads" 
        description=" "
        image={serviceMap.fb.img}>
            <FacebookAdsClaimCard design="onboarding" />
            <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                    {siteForm?.attr?.accounts?.fb && localStorage.getItem("fbSelection") !== null && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                        Edit
                    </button>}
                    {siteForm?.attr?.accounts?.fb && oauthTokens?.fb ? <button id="saveFb" className="btn btn-lg btn-primary" onClick={async() => {
                        await onSave("fb")
                    }}>Save</button> : <div></div>}
                </div>
                {(!siteForm?.attr?.accounts?.fb || localStorage.getItem("fbSelection") === null) && <button className="btn btn-lg btn-link" onClick={() =>onCancel("fb")}>Claim Later</button>}
            </div>
    </ServiceCardBase>
}

export default FacebookAds